import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
const api = axios.create({ baseURL: '/api', timeout: 15000 });

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('nm_token');
    if (!token) { setLoading(false); return; }
    api.get('/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { setUser(r.data); setLoading(false); })
      .catch(() => { localStorage.removeItem('nm_token'); setLoading(false); });
  }, []);

  function login(token, userData) {
    localStorage.setItem('nm_token', token);
    setUser(userData);
  }

  function logout() {
    localStorage.removeItem('nm_token');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
